const getCustomURLsInternal = () => {
  const url = window.location.origin;

  if (process.env.REACT_APP_ENV_NAME === "development") {
    switch (url) {
      case "http://localhost:3000":
        return ({
          // SERVER_URL: "https://dev-api.fanceetickets.com",
          // API_URL: "https://dev-api.fanceetickets.com/v1",
          SERVER_URL: "https://localhost:5001/",
          API_URL: "https://localhost:5001/v1",
          PUBLIC_URL: url,
        });

      case "https://dev-app.fanceetickets.com":
        return ({
          SERVER_URL: "https://dev-api.fanceetickets.com",
          API_URL: "https://dev-api.fanceetickets.com/v1",
          PUBLIC_URL: url,
        });

      case "https://dev-app.sixtix.com": // require input correct data
        return ({
          SERVER_URL: "https://dev-api.sixtix.com", // require input correct data
          API_URL: "https://dev-api.sixtix.com/v1", // require input correct data
          PUBLIC_URL: url, // require input correct data
        });

      case "https://dev-app.headworks.com.ua": // require input correct data
        return ({
          SERVER_URL: "https://dev-api.headworks.com.ua", // require input correct data
          API_URL: "https://dev-api.headworks.com.ua/v1", // require input correct data
          PUBLIC_URL: url, // require input correct data
        });

      case "https://dev-app.france.fr": // require input correct data
        return ({
          SERVER_URL: "https://dev-api.france.fr", // require input correct data
          API_URL: "https://dev-api.france.fr/v1", // require input correct data
          PUBLIC_URL: url, // require input correct data
        });

      case "https://dev-app.partizan.basketball":
        return ({
          SERVER_URL: "https://dev-api.partizan.basketball",
          API_URL: "https://dev-api.partizan.basketball/v1",
          PUBLIC_URL: url,
        });

      default:
        return ({
          SERVER_URL: "https://dev-api.fanceetickets.com",
          API_URL: "https://dev-api.fanceetickets.com/v1",
          PUBLIC_URL: url,
        });
    }
  } else if (process.env.REACT_APP_ENV_NAME === "production") {
    switch (url) {
      case "https://app.fanceetickets.com":
        return ({
          SERVER_URL: "https://api.fanceetickets.com",
          API_URL: "https://api.fanceetickets.com/v1",
          PUBLIC_URL: url,
        });

      case "https://app.sixtix.com":
        return ({
          SERVER_URL: "https://api.sixtix.com",
          API_URL: "https://api.sixtix.com/v1",
          PUBLIC_URL: url,
        });

      case "https://app.sixtix.rs":
        return ({
          SERVER_URL: "https://api.sixtix.rs",
          API_URL: "https://api.sixtix.rs/v1",
          PUBLIC_URL: url,
        });

      case "https://app.sixtix.nl":
        return ({
          SERVER_URL: "https://api.sixtix.nl",
          API_URL: "https://api.sixtix.nl/v1",
          PUBLIC_URL: url,
        });

      case "https://app.partizan.basketball":
        return ({
          SERVER_URL: "https://api.partizan.basketball",
          API_URL: "https://api.partizan.basketball/v1",
          PUBLIC_URL: url,
        });

      case "https://app.france.fr":
        return ({
          SERVER_URL: "https://api.france.fr",
          API_URL: "https://api.france.fr/v1",
          PUBLIC_URL: url,
        });

      case "https://app.partizan.basketball":
        return ({
          SERVER_URL: "https://api.partizan.basketball",
          API_URL: "https://api.partizan.basketball/v1",
          PUBLIC_URL: url,
        });

      default:
        return ({
          SERVER_URL: "https://api.fanceetickets.com",
          API_URL: "https://api.fanceetickets.com/v1",
          PUBLIC_URL: url,
        });
    }
  }
};

export const getCustomURLs = () => {
  const result = getCustomURLsInternal();

  const hardApi = localStorage.getItem('ufo_url');
  if (!!hardApi)
  {
    result.SERVER_URL = hardApi;
    result.API_URL = hardApi + '/v1';
  }

  return result;
}
